/**
 * Navigation service for use outside React components
 * 
 * This provides a way to navigate from places like axios interceptors,
 * error boundaries, and service files without using window.location.href
 */

let navigateFunction = null;

/**
 * Set the navigate function (called from NavigationSetter component)
 */
export const setNavigate = (navigate) => {
  navigateFunction = navigate;
};

/**
 * Navigate to a route from anywhere in the app
 * Falls back to history API if navigate function not set
 */
export const navigateTo = (path) => {
  if (navigateFunction) {
    navigateFunction(path);
  } else {
    // Fallback - use history API which React Router will detect
    console.warn('NavigationService: navigate function not set, using fallback');
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  }
};

/**
 * Get the navigate function directly (for components that can't use hooks)
 */
export const getNavigate = () => navigateFunction;
